import React from 'react';
import { compose } from 'ramda';
import { branch, renderNothing } from 'recompose';
import { withTranslations } from 'js/components/hocs/withTranslations';
import { Link } from 'js/components/common/Link';
import style from './index.scss';

export const TermsAndConditions = ({ termsAndConditionsUrl, className = '', t }) => (
    <div className={style.container}>
        <Link
            href={termsAndConditionsUrl}
            inNewWindow={true}
            className={`${style.link} ${className}`}>
            {t('playtech.mobile.system.leaderboard.termsAndConditions')}
        </Link>
    </div>
);

export default compose(
    branch(
        ({ termsAndConditionsUrl }) => !termsAndConditionsUrl,
        renderNothing
    ),
    withTranslations
)(TermsAndConditions);
